import script from "./edit-profile-form.vue?vue&type=script&setup=true&lang=ts"
export * from "./edit-profile-form.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__